<template>
  <div class="pdt-2" >
    <div class="flex">
      <h4 @click="selected = null" class="subtitle is-4">Витрати за {{day}}</h4>
      <button @click="addModalShow = true" class="mgl-1 button is-primary">добавить</button>
    </div>
    <b-table v-if="data" :data="data" :selected.sync="selected" striped hoverable>
      <template slot-scope="props">
        <b-table-column field="name" label="Краткое название">{{ props.row.name }}</b-table-column>
        <b-table-column field="phone" label="Цена">{{ props.row.price }} грн</b-table-column>
        <b-table-column field="number" label="Описание">{{ props.row.desc }}</b-table-column>
      </template>
    </b-table>

    <b-modal :active.sync="addModalShow" has-modal-card>
      <section>
        <div class="modal-bg">
          <b-field>
            <b-input placeholder="Название" v-model="name"></b-input>
          </b-field>
          <b-field>
            <b-input placeholder="цена" type="number" v-model="price"></b-input>
          </b-field>
          <b-field>
            <b-input placeholder="описание" maxlength="200" v-model="desc" type="textarea"></b-input>
          </b-field>
          <div class="control">
            <button class="button is-link" @click="addCostHandle()">відправити</button>
          </div>
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Array
    },
    day: {
      type: String,
      default: "сьогодні"
    }
  },
  data() {
    return {
      selected: null,
      addModalShow: false,
      name: "",
      price: "",
      desc: ""
    };
  },
  methods: {
    ...mapActions(["addCost"]),
    async addCostHandle() {
      await this.addCost({
        name: this.name,
        price: this.price,
        desc: this.desc
      }).then(() => {
        this.addModalShow = false;
        this.name = "";
        this.price = "";
        this.desc = "";
        this.$buefy.snackbar.open({
          duration: 5000,
          message: "Добавлено!"
        });
      });
      this.$emit('refresh')
    }
  }
};
</script>

